/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 8966d24256b2
 */

export const mcpScopes = [
  "admin",
  "builder",
] as const;

export type MCPScope = (typeof mcpScopes)[number];
